module.exports = __webpack_public_path__ + "img/data-zhCn.6ff1bb00.png";